// api/v1/user/{customerId}/bucket/emergency/transactions" GET
//
// Query params: "startDate", "endDate", "page" & "recordCnt"
import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';

const { CONTROLLERS: { EMERGENCY_BUCKET_TRANSACTIONS: { BASE, VERSION } } } = USER;

export const useEmergencyBucketTransactionsQuery = ({ customerId, query, enabled }: { customerId: string, query: string, enabled: boolean }) => useQuery(
  'emergency-bucket-transactions',
  async () => {
    if (!customerId || !query) {
      return null;
    }
    const { data } = await httpService.get((`${BASE_URL}/api/${VERSION}/user/${customerId}/${BASE}?${query}`));
    return data;
  },
  {
    enabled,
    cacheTime: 0,
    staleTime: 0,
    refetchOnWindowFocus: false,
  },
);
